export default "__VITE_ASSET__cec6c5ac__"